import { Origin } from "@/constants/share";

// 板端二维码旧链接为'-', 新版改为'_',  兼容旧链接
const formatOrigin = (origin?: string) => {
  return origin?.replace("-", "_") as Origin;
};
export default formatOrigin;
